import { getDatesNumber } from './index';
const checkIfAllowUpdateByDate = (firstDateString, secondDateString) => {
  if (!firstDateString || !secondDateString) {
    return false;
  }
  let { firstDate, secondDate } = getDatesNumber(firstDateString, secondDateString);

  return firstDate >= secondDate;
};

export default checkIfAllowUpdateByDate;
